import { render, staticRenderFns } from "./EditOwner.vue?vue&type=template&id=7280cd0a&"
import script from "./EditOwner.vue?vue&type=script&lang=js&"
export * from "./EditOwner.vue?vue&type=script&lang=js&"
import style0 from "./EditOwner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports